import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSetState } from '@campaignhub/react-hooks'
import { useSelector } from 'react-redux'

import useReduxAction from '@hooks/useReduxAction'

import { Box, Text } from '@campaignhub/suit-theme'

import useFilter from '@hooks/useFilter'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEye, faPlus,
} from '@fortawesome/pro-light-svg-icons'

import View from './components/View'

const defaultState = {
  customViewState: [],
  selectedCustomView: null,
}

const ViewFilter = (props) => {
  const { setJobState, jobState } = props
  const { customFilter } = jobState

  const entities = useSelector(reduxState => reduxState.entities)
  const { filters } = entities

  const filtersOptions = {
    entityType: 'serviceJob',
    ...customFilter?.length && { customFilters: customFilter.join(',') },
  }

  useReduxAction('filters', 'loadFilters', filtersOptions, [customFilter])

  const [state, setState] = useSetState(defaultState)
  const { customViewState, selectedCustomView } = state

  const initFilter = { id: null }
  const { callbacks: { launchCreateServiceJobViewModal } } = useFilter(initFilter)

  useEffect(() => {
    setState({
      customViewState: Object.values(filters).map(filter => ({
        ...filter,
        isChecked: selectedCustomView === filter.id,
      })),
    })
  }, [filters, selectedCustomView])

  const updateCustomView = (checked, view) => {
    if (checked){
      setJobState({
        clientFilter: view.clients,
        dateFilter: {
          filterStart: view.filterStart,
          filterEnd: view.filterEnd,
        },
        serviceFilter: view.services,
        statusFilter: view.serviceJobStatuses,
        userFilter: view.users,
        serviceUserFilter: view.serviceUsers,
        classificationFilter: view.classifications,
        accountManagerFilter: view.accountManagers,
      })
    } else {
      setJobState({
        clientFilter: [],
        dateFilter: {
          filterStart: '',
          filterEnd: '',
        },
        serviceFilter: [],
        statusFilter: [],
        userFilter: [],
        serviceUserFilter: [],
        classificationFilter: [],
        accountManagerFilter: [],
      })
    }

    setState({ selectedCustomView: checked ? view.id : null })
  }

  return (
    <Box flexDirection="column">
      <Box
        flexDirection="row"
        style={{ cursor: 'pointer' }}
        marginBottom={customViewState.length ? 'medium' : null}
      >
        <Box
          color="bodyFontLightColor"
          marginLeft="auto"
          width="auto"
          marginRight="medium"
        >
          <FontAwesomeIcon icon={faEye} />
        </Box>
        <Box flexDirection="column">
          <Text
            color="bodyFontLightColor"
            fontSize="small"
            fontWeight="medium"
            fontAlign="center"
          >
            Views
          </Text>
        </Box>
        <Box
          color="bodyFontLightColor"
          marginLeft="medium"
          width="auto"
          marginRight="auto"
          onClick={launchCreateServiceJobViewModal}
        >
          <FontAwesomeIcon icon={faPlus} />
        </Box>
      </Box>
      <Box flexDirection="column" alignItems="center" lineHeight="1.5">
        {customViewState.map(view => <View key={view.id} view={view} updateCustomView={updateCustomView} />)}
      </Box>
    </Box>
  )
}

ViewFilter.propTypes = {
  setJobState: PropTypes.func,
  jobState: PropTypes.object,
}

export default ViewFilter
